/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {startStorefrontLogin} from '../api'

export const useMutationStartStorefrontLogin = createReactQueryMutationHook('startStorefrontLogin', startStorefrontLogin)
